import { useMutation, useQueryClient } from "@tanstack/react-query";

import { ConsentTypeEnumType } from "@libs/api/patients";

import { ConsentsApi } from "../api/consentsApi";
import { ConsentsQueryKeys } from "../queries/consentsQueries";

export const useCreatePatientConsentMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      consentType,
      isConsented,
    }: {
      consentType: ConsentTypeEnumType;
      isConsented: boolean;
    }) => ConsentsApi.createPatientConsent({ consentType, isConsented }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ConsentsQueryKeys.all,
      });
    },
  });
};
